export default "__VITE_ASSET__BBG_eUCp__"